import type {
	CorporatePartner,
	CreateCorporatePartnerBody,
	ListCorporatePartnersParams,
	UpdateCorporatePartnerBody,
} from "@/features/partners/types";
import { toAdminSearchParams } from "@/shared/api/admin-list";
import { api } from "@/shared/api/client";
import type { InfinityPage } from "@/shared/api/types";

export async function listCorporatePartners(
	params: ListCorporatePartnersParams = {},
): Promise<InfinityPage<CorporatePartner>> {
	return api
		.get("admin/corporate-partners", {
			searchParams: toAdminSearchParams({
				...params,
				sort: params.sort ?? "createdAt",
				order: params.order ?? "DESC",
			}),
		})
		.json();
}

export async function createCorporatePartner(
	body: CreateCorporatePartnerBody,
): Promise<CorporatePartner> {
	return api.post("admin/corporate-partners", { json: body }).json();
}

export async function updateCorporatePartner(
	id: string,
	body: UpdateCorporatePartnerBody,
): Promise<CorporatePartner> {
	return api.patch(`admin/corporate-partners/${id}`, { json: body }).json();
}

export async function deleteCorporatePartner(id: string): Promise<void> {
	await api.delete(`admin/corporate-partners/${id}`);
}

export async function addPartnerDomain(
	id: string,
	domain: string,
): Promise<CorporatePartner> {
	return api
		.post(`admin/corporate-partners/${id}/domains`, { json: { domain } })
		.json();
}

export async function updatePartnerDomain(
	id: string,
	domainId: string,
	domain: string,
): Promise<CorporatePartner> {
	return api
		.patch(`admin/corporate-partners/${id}/domains/${domainId}`, {
			json: { domain },
		})
		.json();
}

export async function removePartnerDomain(
	id: string,
	domainId: string,
): Promise<void> {
	await api.delete(`admin/corporate-partners/${id}/domains/${domainId}`);
}

export const partnerKeys = {
	all: ["admin-corporate-partners"] as const,
	list: (params: ListCorporatePartnersParams) =>
		["admin-corporate-partners", "list", params] as const,
};
